// extracted by mini-css-extract-plugin
module.exports = {"w10q2eaw":"w10q2eaw","bumr6ev":"bumr6ev","bd9xvgh":"bd9xvgh","cfwu52t":"cfwu52t"};